
import { RouteObject } from 'react-router-dom';
import Game from '../pages/game/page';
import Home from '../pages/home/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Game />,
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '*',
    element: <NotFound />,
  }
];

export default routes;
